module.exports = __webpack_public_path__ + "static/media/cliente-crestani.a8168d9e.webp";